// eslint-disable-next-line import/prefer-default-export
export const SCOPE = 'noc';
export const INIT = `${SCOPE}/INIT`;
export const RESET = `${SCOPE}/RESET`;
